import { Clip } from '@stores/MomentMerge/MomentMergeStore';
import { useMemo } from 'react';
import { ClipStore } from '../types';

interface UseMemoizedCalculationsParams {
  store: ClipStore;
  activeVideo: 'video1' | 'video2';
  video1Loading: boolean;
  video2Loading: boolean;
  video1Clip: Clip | null;
  video2Clip: Clip | null;
}

export const useMemoizedCalculations = ({
  store,
  activeVideo,
  video1Loading,
  video2Loading,
  video1Clip,
  video2Clip,
}: UseMemoizedCalculationsParams) => {
  // Get current clip info based on global timestamp
  const currentClipInfo = useMemo(() => {
    return store.clipInTimestamp(store.currentTime);
  }, [store, store.currentTime]);

  // Calculate if the active video is loading
  const isActiveVideoLoading = useMemo(() => {
    if (activeVideo === 'video1') {
      return video1Loading && video1Clip !== null;
    } else {
      return video2Loading && video2Clip !== null;
    }
  }, [activeVideo, video1Loading, video2Loading, video1Clip, video2Clip]);

  // Calculate progress percentage
  const progressPercentage = useMemo(() => {
    if (store.totalClipsDuration <= 0) return 0;
    return (store.currentTime / store.totalClipsDuration) * 100;
  }, [store.currentTime, store.totalClipsDuration]);

  return {
    currentClipInfo,
    isActiveVideoLoading,
    progressPercentage,
  };
};
